import { Theme } from '@chargify/custom-ui-components';

import { CreditCardPCIFields } from '../../../types';

const INPUT_HEIGHT = '28px';

/**
 * Creates fields styling
 * @param {Theme} theme - component theme
 * @returns Fields styling definition
 */
const createFieldsStyles = (theme: Theme) => {
  const { fonts } = theme;

  const inputStyles = {
    background: 'none',
    'box-shadow': 'none',
    height: INPUT_HEIGHT,
    'font-family': fonts.secondary,
    'line-height': 1,
    padding: '0 8px',
    border: 'none',
    'border-radius': 0,
  };

  const commonStyles = {
    field: {
      margin: 0,
      padding: 0,
      background: 'none',
    },
    message: {
      display: 'none',
    },
    label: {
      display: 'none',
    },
  };

  const fieldsStyles = {
    [CreditCardPCIFields.ExpirationMonth]: {
      input: {
        ...inputStyles,
        padding: '0 4px 0 8px',
      },
      ...commonStyles,
    },
    [CreditCardPCIFields.ExpirationYear]: {
      input: {
        ...inputStyles,
        padding: '0 8px 0 4px',
      },
      ...commonStyles,
    },
  };

  const globalStyles = {
    input: inputStyles,
    ...commonStyles,
  };

  return {
    fieldsStyles,
    globalStyles,
  };
};

export default createFieldsStyles;
